/**
 * API Endpoints Configuration
 * ============================
 * 
 * Mapeamento centralizado de endpoints.
 * Cutover: Mudando de endpoints legados para v2.
 * 
 * IMPORTANTE: Manter este arquivo atualizado durante o cutover.
 * Rollback: Reverter USE_V2_ANALYTICS para false.
 */

// Feature flag para controle do cutover
export const USE_V2_ANALYTICS = true;

// Mapeamento de endpoints
export const API_ENDPOINTS = {
  // ============================================================================
  // ANALYTICS - OPERATIONS (Kitchen)
  // ============================================================================
  analytics: {
    // Operations
    kitchen: USE_V2_ANALYTICS ? '/analytics/v2/operations/kitchen' : '/analytics/kitchen',
    heatmap: USE_V2_ANALYTICS ? '/analytics/v2/operations/heatmap' : '/analytics/heatmap',
    bottlenecks: USE_V2_ANALYTICS ? '/analytics/v2/operations/bottlenecks' : '/analytics/bottlenecks',
    efficiency: USE_V2_ANALYTICS ? '/analytics/v2/operations/efficiency' : '/analytics/efficiency',
    benchmark: USE_V2_ANALYTICS ? '/analytics/v2/operations/benchmark' : '/analytics/benchmark',
    peakHours: USE_V2_ANALYTICS ? '/analytics/v2/operations/peak-hours' : '/analytics/peak-hours',
    weeklyPattern: USE_V2_ANALYTICS ? '/analytics/v2/operations/weekly-pattern' : '/analytics/weekly-pattern',
    realtimeStatus: USE_V2_ANALYTICS ? '/analytics/v2/operations/realtime-status' : '/analytics/realtime-status',
    productTimes: USE_V2_ANALYTICS ? '/analytics/v2/operations/product-times' : '/analytics/product-times',
  },
  
  // ============================================================================
  // INTELLIGENCE - SALES
  // ============================================================================
  intelligence: {
    // Sales
    profitBrain: USE_V2_ANALYTICS ? '/analytics/v2/sales/profit-brain' : '/intelligence/profit-brain',
    menuIntelligence: USE_V2_ANALYTICS ? '/analytics/v2/sales/menu-intelligence' : '/intelligence/menu-intelligence',
    healthScore: USE_V2_ANALYTICS ? '/analytics/v2/sales/health-score' : '/intelligence/health-score',
    forecast: USE_V2_ANALYTICS ? '/analytics/v2/sales/forecast' : '/intelligence/forecast',
    weeklyReport: USE_V2_ANALYTICS ? '/analytics/v2/sales/weekly-report' : '/intelligence/weekly-report',
    pricing: USE_V2_ANALYTICS ? '/analytics/v2/sales/pricing' : '/intelligence/smart-pricing',
    weakDays: USE_V2_ANALYTICS ? '/analytics/v2/sales/weak-days' : '/intelligence/weak-days',
    summary: USE_V2_ANALYTICS ? '/analytics/v2/sales/summary' : '/intelligence/summary',
    
    // Legacy endpoints that don't have v2 equivalent yet
    crm: '/intelligence/crm',
    predictiveInventory: '/intelligence/predictive-inventory',
    moneyLeaks: '/intelligence/money-leaks',
    recipes: '/intelligence/recipes',
    ingredients: '/intelligence/ingredients',
    cmv: '/intelligence/cmv',
  },
  
  // ============================================================================
  // MARKETING
  // ============================================================================
  marketing: {
    segments: USE_V2_ANALYTICS ? '/analytics/v2/marketing/segments' : '/customers/segments',
    ltv: USE_V2_ANALYTICS ? '/analytics/v2/marketing/ltv' : '/customers/ltv',
    crmDashboard: USE_V2_ANALYTICS ? '/analytics/v2/marketing/crm-dashboard' : '/marketing/crm-dashboard',
    retention: USE_V2_ANALYTICS ? '/analytics/v2/marketing/retention' : '/marketing/retention',
    churn: USE_V2_ANALYTICS ? '/analytics/v2/marketing/churn' : '/marketing/churn',
    inactive: USE_V2_ANALYTICS ? '/analytics/v2/marketing/inactive' : '/customers/inactive',
    referral: USE_V2_ANALYTICS ? '/analytics/v2/marketing/referral' : '/referral/stats',
    upsell: USE_V2_ANALYTICS ? '/analytics/v2/marketing/upsell' : '/marketing/upsell-analytics',
    channels: USE_V2_ANALYTICS ? '/analytics/v2/marketing/channels' : '/marketing/channels',
    campaigns: USE_V2_ANALYTICS ? '/analytics/v2/marketing/campaigns' : '/marketing/campaigns',
    coupons: USE_V2_ANALYTICS ? '/analytics/v2/marketing/coupons' : '/marketing/coupons',
  },
  
  // ============================================================================
  // PLATFORM (Admin only)
  // ============================================================================
  platform: {
    mrr: USE_V2_ANALYTICS ? '/analytics/v2/platform/mrr' : '/platform-metrics/mrr',
    revenueBreakdown: USE_V2_ANALYTICS ? '/analytics/v2/platform/revenue-breakdown' : '/platform-metrics/revenue',
    mrrTrend: USE_V2_ANALYTICS ? '/analytics/v2/platform/mrr-trend' : '/platform-metrics/mrr-trend',
    tenants: USE_V2_ANALYTICS ? '/analytics/v2/platform/tenants' : '/platform-metrics/tenants',
    tenantChurn: USE_V2_ANALYTICS ? '/analytics/v2/platform/tenant-churn' : '/platform-metrics/churn',
    tenantDistribution: USE_V2_ANALYTICS ? '/analytics/v2/platform/tenant-distribution' : '/platform-metrics/distribution',
    recentTenants: USE_V2_ANALYTICS ? '/analytics/v2/platform/recent-tenants' : '/platform-metrics/recent',
    usage: USE_V2_ANALYTICS ? '/analytics/v2/platform/usage' : '/platform-metrics/usage',
    aiUsage: USE_V2_ANALYTICS ? '/analytics/v2/platform/ai-usage' : '/ai/usage/stats',
    activityScores: USE_V2_ANALYTICS ? '/analytics/v2/platform/activity-scores' : '/platform-metrics/activity',
    health: USE_V2_ANALYTICS ? '/analytics/v2/platform/health' : '/system-health/status',
    services: USE_V2_ANALYTICS ? '/analytics/v2/platform/services' : '/system-health/services',
  },
};

// Helper function to get endpoint with query params
export const buildUrl = (endpoint, params = {}) => {
  const queryString = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return queryString ? `${endpoint}?${queryString}` : endpoint;
};

export default API_ENDPOINTS;
